module.exports = __webpack_public_path__ + "img/fujilogo-p-500.9b5592fc.png";